// src/pages/TermsOfService.js

import React from "react";

export default function Terms() {
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: 1.7,
      }}
    >
      <h1>Terms of Service</h1>

      <p>
        <strong>Last Updated:</strong> June 7, 2026
      </p>

      <h2>1. Acceptance of Terms</h2>

      <p>
        By accessing or using the services provided by [COMPANY NAME]
        ("Company", "we", "our", or "us"), you agree to be bound by
        these Terms of Service.
      </p>

      <p>
        If you do not agree to these Terms, you may not use our
        Services.
      </p>

      <h2>2. Description of Services</h2>

      <p>
        We provide software tools and services that may include:
      </p>

      <ul>
        <li>Lead generation and prospecting</li>
        <li>Email discovery and enrichment</li>
        <li>AI-powered content generation</li>
        <li>Marketing automation</li>
        <li>Outreach campaign creation</li>
        <li>Analytics and reporting</li>
        <li>Business management tools</li>
      </ul>

      <p>
        We reserve the right to modify, suspend, or discontinue any
        feature at any time without notice.
      </p>

      <h2>3. Account Registration</h2>

      <p>
        To use certain features, you may be required to create an
        account.
      </p>

      <p>You agree to:</p>

      <ul>
        <li>Provide accurate information</li>
        <li>Maintain the security of your account</li>
        <li>Keep login credentials confidential</li>
        <li>Notify us of unauthorized account access</li>
      </ul>

      <p>
        You are responsible for all activities that occur under your
        account.
      </p>

      <h2>4. User Responsibilities</h2>

      <p>You agree not to:</p>

      <ul>
        <li>Violate any applicable law or regulation</li>
        <li>Send unlawful, fraudulent, or deceptive communications</li>
        <li>Misuse lead or contact information</li>
        <li>Attempt unauthorized access to our systems</li>
        <li>Interfere with platform operations</li>
        <li>Upload malicious software or code</li>
        <li>Use the Services for spam or abusive conduct</li>
      </ul>

      <h2>5. Lead Data & Compliance</h2>

      <p>
        Users are solely responsible for ensuring their use of lead
        data, prospect information, and outreach campaigns complies
        with all applicable laws and regulations.
      </p>

      <p>Including but not limited to:</p>

      <ul>
        <li>CAN-SPAM Act</li>
        <li>GDPR</li>
        <li>CCPA</li>
        <li>CASL</li>
        <li>ePrivacy Regulations</li>
      </ul>

      <p>
        We do not guarantee the legality, accuracy, completeness,
        availability, or deliverability of any lead or contact data.
      </p>

      <h2>6. AI Generated Content</h2>

      <p>
        Our platform may generate content using artificial intelligence.
      </p>

      <p>
        AI-generated content may contain inaccuracies, omissions, or
        outdated information.
      </p>

      <p>
        You are solely responsible for reviewing, verifying, editing,
        and approving all generated content before publication or use.
      </p>

      <h2>7. Third-Party Services</h2>

      <p>
        Certain functionality depends on third-party providers.
      </p>

      <p>These providers may include:</p>

      <ul>
        <li>Stripe</li>
        <li>Supabase</li>
        <li>Apollo.io</li>
        <li>Hunter.io</li>
        <li>Instantly</li>
        <li>Anthropic</li>
        <li>Resend</li>
      </ul>

      <p>
        We are not responsible for the availability, accuracy,
        actions, policies, or performance of third-party services.
      </p>

      <h2>8. Subscription & Billing</h2>

      <p>
        Certain Services require a paid subscription.
      </p>

      <p>
        By purchasing a subscription, you authorize recurring charges
        according to your selected plan.
      </p>

      <p>
        Subscription fees are non-refundable except where required by
        law.
      </p>

      <p>
        We reserve the right to modify pricing at any time.
      </p>

      <h2>9. Cancellation</h2>

      <p>
        You may cancel your subscription at any time.
      </p>

      <p>
        Cancellation will prevent future billing but will not result
        in refunds for already billed periods unless required by law.
      </p>

      <h2>10. Intellectual Property</h2>

      <p>
        All software, trademarks, logos, designs, content, source
        code, and proprietary technology associated with the Services
        remain the exclusive property of [COMPANY NAME].
      </p>

      <p>
        These Terms do not grant ownership rights to users.
      </p>

      <h2>11. User Content</h2>

      <p>
        You retain ownership of content you submit to the Services.
      </p>

      <p>
        By submitting content, you grant us a limited license to host,
        process, store, and display that content solely for providing
        the Services.
      </p>

      <h2>12. Service Availability</h2>

      <p>
        We strive to maintain reliable service but do not guarantee:
      </p>

      <ul>
        <li>Continuous availability</li>
        <li>Uninterrupted operation</li>
        <li>Error-free functionality</li>
        <li>Specific performance levels</li>
      </ul>

      <p>
        Maintenance, outages, third-party failures, and technical
        issues may impact availability.
      </p>

      <h2>13. Disclaimer of Warranties</h2>

      <p>
        THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE".
      </p>

      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL
        WARRANTIES, EXPRESS OR IMPLIED, INCLUDING:
      </p>

      <ul>
        <li>MERCHANTABILITY</li>
        <li>FITNESS FOR A PARTICULAR PURPOSE</li>
        <li>NON-INFRINGEMENT</li>
        <li>ACCURACY OF DATA</li>
        <li>BUSINESS RESULTS</li>
      </ul>

      <h2>14. Limitation of Liability</h2>

      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, [COMPANY NAME] SHALL
        NOT BE LIABLE FOR:
      </p>

      <ul>
        <li>Lost profits</li>
        <li>Lost revenue</li>
        <li>Lost business opportunities</li>
        <li>Data loss</li>
        <li>Indirect damages</li>
        <li>Consequential damages</li>
        <li>Special damages</li>
      </ul>

      <p>
        OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU
        FOR THE SERVICES DURING THE PRECEDING TWELVE (12) MONTHS.
      </p>

      <h2>15. Indemnification</h2>

      <p>
        You agree to defend, indemnify, and hold harmless
        [COMPANY NAME], its officers, employees, and affiliates from
        any claims, damages, liabilities, costs, and expenses arising
        from:
      </p>

      <ul>
        <li>Your use of the Services</li>
        <li>Your violation of these Terms</li>
        <li>Your outreach campaigns</li>
        <li>Your violation of applicable laws</li>
      </ul>

      <h2>16. Account Suspension & Termination</h2>

      <p>
        We may suspend or terminate access at our sole discretion for:
      </p>

      <ul>
        <li>Violation of these Terms</li>
        <li>Fraudulent activity</li>
        <li>Abuse of the platform</li>
        <li>Legal compliance requirements</li>
      </ul>

      <h2>17. Governing Law</h2>

      <p>
        These Terms shall be governed by and interpreted under the
        laws of [STATE/COUNTRY], without regard to conflict of law
        principles.
      </p>

      <h2>18. Changes to Terms</h2>

      <p>
        We may modify these Terms from time to time.
      </p>

      <p>
        Continued use of the Services after updates constitutes
        acceptance of the revised Terms.
      </p>

      <h2>19. Contact Information</h2>

      <p>
        If you have questions regarding these Terms, contact:
      </p>

      <p>
        <strong>[COMPANY NAME]</strong>
        <br />
        Email: [SUPPORT EMAIL]
        <br />
        Website: [YOUR WEBSITE]
      </p>
    </div>
  );
}
